import { createAction, createSlice } from '@reduxjs/toolkit';


export type Holiday = {
    date: string,
    day: string,
    holiday: string
}


const initialState: Holiday = {
    date: '',
    day: '',
    holiday: ''
};

export const revertAll = createAction('REVERT_ALL');

// Redux Toolkit slice
export const holidayReducer: any = createSlice({
    name: 'holiday',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setHoliday: (state, action) => {
            return {
                ...action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(revertAll, () => initialState);
    },
});
export const { setHoliday } = holidayReducer.actions;
export default holidayReducer;